import React from "react";
import { FooterData } from "../../fakeData/Footer";
import { Link } from "react-router-dom";
import LogoColor from "../../assets/img/logo-color.png";
import PaymentImg from "../../assets/img/payment-logo.png";

function Footer() {
  return (
    <>
      <hr className="hr-line" />
      <div className="border-t border-gray-100 bg-gradient-to-r from-green-200 via-indigo-100 to-green-100 w-full">
        <div className="pb-16 lg:pb-0 xl-pb-0">
          <div className="mx-auto max-w-screen-2xl px-4 sm:px-10">
            {/* Footer Links */}
            <div className="grid grid-cols-2 md:grid-cols-7 xl:grid-cols-12 py-10 lg:py-16 justify-between">
              {FooterData.map((data, index) => {
                return (
                  <div
                    key={index}
                    className="pb-3.5 sm:pb-0 col-span-1 md:col-span-2 lg:col-span-3"
                  >
                    <h3 className="text-md lg:leading-7 font-medium mb-4 sm:mb-5 lg:mb-6 pb-0.5">
                      {data.titleHeader}
                    </h3>
                    <ul className="text-sm flex flex-col space-y-3" key={index}>
                      {data.title.map((title, index) => {
                        return (
                          <li key={index} className="flex items-baseline">
                            <Link
                              className="!text-gray-600 inline-block w-full !no-underline hover:!text-emerald-500"
                              to={title.href}
                            >
                              {title.Name}
                            </Link>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                );
              })}

              {/* Address Section */}
              <div className="pb-3.5 sm:pb-0 col-span-1 md:col-span-3 lg:col-span-4">
                <p className="leading-7 font-sans text-sm text-gray-600">
                  <span>
                    332/12, BARVE NAGAR, GHATKOPAR <br /> MUMBAI 400084 ,
                    MAHARASHTRA (INDIA)
                  </span>
                  <br />
                  <span>E-mail: ashtenglobal@gmail.com</span>
                </p>
              </div>

              {/* Follow Us Section beside address */}
              
            </div>

            <hr className="hr-line" />

            {/* Copyright */}
            <div className="mx-auto max-w-screen-2xl px-3 sm:px-10 flex justify-center bg-brand py-4">
              <p className="text-sm text-white leading-6">
                Copyright {new Date().getFullYear()}
                <span className="text-white"> @Ashten Global </span>, All rights
                reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
